<script lang="ts" setup>
import { computed } from 'vue';
import config from '@/config/ConfigProvider';
import { useLocale } from '@/plugins/translation';

const { t, l } = useLocale();
const serviceName = config.value('serviceName');
const logoImageFile = config.value('logoImageFile');
const logoImage = computed(() => new URL(`/src/assets/images/${logoImageFile}`, import.meta.url).href);
</script>

<template>
  <v-container class="text-center">
    <v-row justify="center" class="mt-9">
      <v-col xs="12" lg="6">
        <v-img :src="logoImage" cover :alt="serviceName + ' logo'" />
      </v-col>
    </v-row>
    <v-row justify="center" class="my-15">
      <v-col class="text-secondary">
        <h1>{{ t(l.page_not_found.description) }}</h1>
        <p>{{ t(l.page_not_found.title) }}</p>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col sm="8" xl="8">
        <v-btn rounded="xl" to="/" size="x-large" color="secondary">
          <span class="text-white">{{ t(l.page_not_found.action) }}</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
